import { useState } from "react";
import { toast } from "sonner";
import { api, errText } from "../../../lib/api";
import { useAuth } from "../../../context/AuthContext";
import { EmployeePickList } from "./EmployeePickList";
import { MarkFormFields } from "./MarkFormFields";
import { useEmployeeSelection } from "../../../hooks/useEmployeeSelection";

const today = () => new Date().toISOString().slice(0, 10);

export const MarkAttendanceForm = ({ onMarked }) => {
  const { user: me } = useAuth();
  const { shown, selected, setSelected, search, setSearch, toggle, allShownSelected, toggleAll } = useEmployeeSelection(me);
  const [form, setForm] = useState({ date: today(), check_in: "09:00", check_out: "18:00", half_day: false });
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const setDayType = (e) => {
    const half = e.target.value === "half";
    setForm({ ...form, half_day: half, check_out: half ? "13:30" : "18:00" });
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!selected.length) { toast.error("Select at least one employee"); return; }
    setBusy(true);
    try {
      const r = await api.post("/attendance/manual/bulk", { ...form, user_ids: selected });
      toast.success(r.data.message);
      setSelected([]);
      onMarked(form.date);
    } catch (err) { toast.error(errText(err)); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="bg-white border border-stone-200 rounded-lg p-5 space-y-4" data-testid="mark-attendance-form">
      <MarkFormFields form={form} set={set} setDayType={setDayType} search={search} setSearch={setSearch} />

      <EmployeePickList shown={shown} selected={selected} toggle={toggle}
        allShownSelected={allShownSelected} toggleAll={toggleAll} />
      {me?.role === "hr_admin" && (
        <p className="text-xs text-stone-400">Your own record isn't listed — only a Super Admin can mark an HR/Admin's attendance.</p>
      )}

      <button type="submit" disabled={busy} data-testid="mark-attendance-submit"
        className="tap-scale px-6 py-3 rounded-full bg-primary text-white text-sm font-bold hover:bg-[#A63F08] transition-colors duration-200 disabled:opacity-60">
        {busy ? "Marking…" : `Mark ${selected.length || ""} ${selected.length === 1 ? "employee" : "employees"} ${form.half_day ? "half day" : "present"}`}
      </button>
    </form>
  );
};
